export const mr = {
  nav: {
    home: "मुख्यपृष्ठ",
    about: "आमच्याबद्दल",
    services: "सेवा",
    doctors: "डॉक्टर्स",
    branches: "शाखा",
    gallery: "गॅलरी",
    contact: "संपर्क",
    bookAppointment: "अपॉइंटमेंट बुक करा",
    call: "कॉल",
    whatsapp: "व्हॉट्सॲप",
    book: "बुक करा"
  },
  hero: {
    society: "श्री टेकके नेत्र रुग्णालय आणि साईट केअर सोसायटी",
    titleLine1: "स्पष्ट दृष्टी.",
    titleLine2: "उत्तम काळजी.",
    description: "आपल्या डोळ्यांच्या आरोग्यासाठी समर्पित, विश्वासार्ह व प्रगत नेत्रसेवा. ६ आधुनिक शाखांमध्ये तज्ज्ञ डॉक्टरांकडून सर्वोत्तम उपचार मिळवा.",
    bookAppointment: "अपॉइंटमेंट बुक करा",
    callNow: "आत्ताच कॉल करा",
    whatsapp: "व्हॉट्सॲप",
    tagline: "आपुलकीने आणि कौशल्याने केलेली नेत्रसेवा",
    counter: "०१ / ०३"
  },
  features: {
    f1Title: "नेत्र आरोग्यावर विशेष लक्ष",
    f1Desc: "आपल्या दृष्टीची सर्वांगीण काळजी",
    f2Title: "रुग्ण-प्रथम दृष्टिकोन",
    f2Desc: "प्रत्येक टप्प्यावर काळजीपूर्वक उपचार",
    f3Title: "६ आधुनिक शाखा केंद्रे",
    f3Desc: "आपल्या घराच्या जवळ उपलब्ध नेत्रसेवा",
    f4Title: "सर्व वयोगटांसाठी उपचार",
    f4Desc: "लहानांपासून ज्येष्ठ नागरिकांपर्यंत"
  },
  trust: {
    happyPatients: "समाधानी रुग्ण",
    expertDoctors: "तज्ज्ञ डॉक्टर्स",
    yearsExperience: "वर्षांचा प्रदीर्घ अनुभव",
    advancedBranches: "सुसज्ज शाखा"
  },
  servicesSection: {
    badge: "आमच्या सेवा",
    title: "प्रत्येक दृष्टीसाठी परिपूर्ण उपचार.",
    subtitle: "आधुनिक तंत्रज्ञान आणि तज्ज्ञ नेत्रशल्यचिकित्सक यांच्या माध्यमातून आपल्या डोळ्यांचे आरोग्य सुरक्षित ठेवा. आम्ही १६ हून अधिक विशेष उपचार प्रदान करतो.",
    viewAll: "सर्व सेवा पहा",
    learnMore: "अधिक जाणून घ्या",
    bookNow: "आत्ताच बुक करा",
    bookConsultation: "सल्लामसलत बुक करा",
    enquire: "चौकशी करा",
    pageBadge: "विशेष उपचार • १६ प्रगत नेत्रसेवा",
    pageTitle: "आमच्या सेवा",
    pageSubtitle: "अत्याधुनिक तंत्रज्ञान आणि तज्ज्ञ डॉक्टरांच्या मार्गदर्शनाखाली सर्वसमावेशक डोळ्यांचे उपचार आणि सूक्ष्म शस्त्रक्रिया. आपली दृष्टी सुरक्षित हातात आहे."
  },
  doctorsSection: {
    badge: "आमचे तज्ज्ञ",
    title: "आपल्या डॉक्टरांना भेटा.",
    subtitle: "आपल्या उत्तम दृष्टीसाठी सदैव कार्यरत असलेले अनुभवी नेत्रशल्यविशारद.",
    meetDoctors: "आमच्या डॉक्टरांना भेटा",
    specialistTag: "नेत्ररोग तज्ज्ञ व शल्यविशारद",
    portraitPlaceholder: "छायाचित्र लवकरच जोडले जाईल",
    bookConsultation: "सल्लामसलत बुक करा",
    pageTitle: "आमचे तज्ज्ञ डॉक्टर्स",
    pageSubtitle: "अनुभवी नेत्रतज्ज्ञ आणि डोळ्यांच्या शस्त्रक्रियेत निष्णात असलेल्या डॉक्टरांना भेटा. आम्ही प्रत्येकाला वैयक्तिक व दर्जेदार नेत्रसेवा देण्यास कटिबद्ध आहोत."
  },
  branchesSection: {
    badge: "आमचे नेटवर्क",
    locationsCount: "६ शाखा",
    title: "नेत्रसेवा, आपल्या अगदी जवळ.",
    subtitle: "महाराष्ट्र आणि कर्नाटकमध्ये अत्याधुनिक तपासणी व शस्त्रक्रिया सुविधांसह आपल्या जवळचे नेत्र रुग्णालय शोधा.",
    viewAll: "सर्व शाखा पहा",
    openToday: "आज सुरू आहे",
    filterDistrict: "शाखा निवडा:",
    allCenters: "सर्व केंद्रे",
    allCentersOpen: "सर्व ६ केंद्रे आज सुरू आहेत",
    dailyOpd: "दैनिक ओपीडी: सकाळी ९ ते रात्री ८",
    branchPrefix: "शाखा",
    of: "पैकी",
    tekkeCenter: "टेकके सेंटर",
    viewDetails: "तपशील पहा",
    call: "कॉल",
    map: "नकाशा",
    details: "तपशील",
    contactNo: "संपर्क क्रमांक",
    pageHeroBadge: "शाखांची माहिती",
    pageHeroTitle: "आमचे सेवा नेटवर्क.",
    pageHeroSubtitle: "महाराष्ट्र आणि कर्नाटकातील ६ आधुनिक शाखांसह, जागतिक दर्जाची नेत्रसेवा आता आपल्या जवळ उपलब्ध आहे.",
    statClinics: "६ क्लिनिक्स",
    statClinicsDesc: "आष्टा, जत, आटपाडी, सोलापूर, अथणी आणि सांगोला",
    statBooking: "२४/७ बुकिंग",
    statBookingDesc: "ऑनलाईन आणि व्हॉट्सॲपवर उपलब्ध",
    findOnMap: "नकाशावर आम्हाला शोधा",
    navigate: "मार्गदर्शन",
    branchInfo: "शाखेची माहिती",
    address: "पत्ता",
    timings: "वेळ",
    availableFacilities: "उपलब्ध सुविधा",
    callBranch: "कॉल करा",
    whatsappMessage: "व्हॉट्सॲप संदेश",
    doctorsAtBranch: "या शाखेतील तज्ज्ञ डॉक्टर",
    bookAtBranch: "या शाखेत अपॉइंटमेंट बुक करा",
    exploreAllMob: "सर्व ६ शाखा व नकाशे पहा"
  },
  missionSection: {
    badge: "साईट केअर सोसायटी",
    title: "रुग्णालयाच्या पलीकडे पाहताना.",
    desc: "आमची साईट केअर सोसायटी गरजू लोकांसाठी मोफत नेत्र तपासणी शिबिरे, जनजागृती कार्यक्रम आणि सवलतीच्या दरात शस्त्रक्रिया उपलब्ध करून देण्यासाठी कार्यरत आहे. स्पष्ट दृष्टी हा प्रत्येकाचा मूलभूत हक्क आहे.",
    findOutMore: "आमच्याबद्दल अधिक जाणून घ्या"
  },
  gallerySection: {
    badge: "गॅलरी",
    title: "आमच्या सेवेची एक झलक.",
    subtitle: "आमच्या अत्याधुनिक सुविधा, आधुनिक तंत्रज्ञान आणि रुग्णसेवेचे काही क्षण.",
    viewFull: "पूर्ण गॅलरी पहा",
    pageTitle: "आमची गॅलरी",
    pageSubtitle: "आमच्या प्रगत नेत्रसेवा सुविधा, निष्ठावंत वैद्यकीय पथक, सामाजिक आरोग्य शिबिरे आणि शाखांमधील आधुनिक पायाभूत सुविधांचे दर्शन.",
    photos: "फोटो",
    all: "सर्व",
    campBadge: "आरोग्य शिबिर",
    clinicBadge: "क्लिनिक व शस्त्रक्रिया गृह",
    close: "बंद करा",
    prev: "मागे",
    next: "पुढे"
  },
  contactSection: {
    badge: "संपर्क साधा",
    title: "आम्ही आपल्या सेवेसाठी तत्पर आहोत.",
    subtitle: "आमची टीम कोणत्याही चौकशीसाठी, मदतीसाठी किंवा तात्काळ नेत्रसेवेसाठी सदैव उपलब्ध आहे.",
    mainClinicBadge: "मुख्य रुग्णालय स्थान",
    mainClinicTitle: "श्री टेकके नेत्र रुग्णालय",
    mainClinicLocation: "सांगली, महाराष्ट्र",
    openInMaps: "गुगल मॅप्सवर उघडा",
    getInTouch: "संपर्क साधा",
    exploreAllBranches: "सर्व शाखा पहा",
    pageTitle: "आमच्याशी संपर्क साधा",
    pageSubtitle: "आम्ही आपल्या मदतीसाठी सदैव उपलब्ध आहोत. कोणत्याही चौकशी, अपॉइंटमेंट किंवा डोळ्यांच्या समस्यांसाठी आमच्याशी संपर्क साधा.",
    mainClinic: "मुख्य रुग्णालय",
    address: "पत्ता",
    phone: "फोन",
    whatsapp: "व्हॉट्सॲप",
    email: "ईमेल",
    workingHours: "कामाची वेळ",
    monSatHours: "सोम - शनि: सकाळी ९:०० ते रात्री ८:००",
    sundayHours: "रविवार: बंद",
    callNow: "आत्ताच कॉल करा",
    messageUs: "संदेश पाठवा",
    sendEmail: "ईमेल पाठवा",
    name: "पूर्ण नाव *",
    phoneNumber: "फोन नंबर *",
    emailAddress: "ईमेल पत्ता",
    subject: "विषय",
    message: "संदेश *",
    submitEnquiry: "चौकशी पाठवा",
    namePlaceholder: "उदा. रमेश पाटील",
    phonePlaceholder: "+९१ ९८७६५ ४३२१०",
    emailPlaceholder: "ramesh@example.com",
    subjectPlaceholder: "आम्ही कशी मदत करू शकतो?",
    messagePlaceholder: "कृपया आपल्या समस्येचे किंवा चौकशीचे वर्णन लिहा...",
    contactSuccess: "आपल्या संदेशाबद्दल धन्यवाद. आमची टीम लवकरच आपल्याशी संपर्क करेल."
  },
  appointmentSection: {
    pageTitle: "अपॉइंटमेंट बुक करा",
    formTitle: "तपासणीसाठी वेळ निश्चित करा",
    formSubtitle: "खालील फॉर्म भरा, आमची टीम आपल्याशी त्वरित संपर्क साधून वेळ निश्चित करेल.",
    fullName: "पूर्ण नाव *",
    phone: "फोन नंबर *",
    email: "ईमेल पत्ता",
    selectBranch: "शाखा निवडा *",
    chooseBranch: "शाखा निवडा...",
    selectDoctor: "डॉक्टर निवडा (पर्यायी)",
    chooseDoctor: "डॉक्टर निवडा...",
    otherDoctor: "इतर डॉक्टर",
    enterDoctorName: "डॉक्टरांचे नाव लिहा",
    selectService: "सेवा निवडा (पर्यायी)",
    chooseService: "सेवा निवडा...",
    preferredDate: "इच्छित तारीख *",
    preferredTime: "इच्छित वेळ *",
    chooseTime: "वेळ निवडा...",
    morning: "सकाळी (९:०० AM - १:०० PM)",
    afternoon: "दुपारी (१:०० PM - ५:०० PM)",
    evening: "संध्याकाळी (५:०० PM - ८:०० PM)",
    message: "अतिरिक्त माहिती (पर्यायी)",
    messagePlaceholder: "डोळ्यांसंबंधी तक्रार किंवा वैद्यकीय इतिहास...",
    submitBtn: "आत्ताच अपॉइंटमेंट बुक करा",
    submitting: "नोंदणी होत आहे...",
    successMsg: "अपॉइंटमेंट बुकिंगसाठी धन्यवाद. आमची टीम लवकरच आपल्याशी संपर्क साधून पुष्टी करेल."
  },
  aboutSection: {
    heroTitle1: "अग्रगण्य",
    heroTitle2: "नेत्रसेवा",
    heroP1: "श्री टेकके आय क्लिनिकची स्थापना एका मुख्य उद्देशाने करण्यात आली: समाजातील प्रत्येक घटकापर्यंत जागतिक दर्जाची आणि परवडणारी नेत्रसेवा पोहोचवणे. अनेक दशकांपासून आम्ही नेत्र आरोग्याच्या क्षेत्रात अग्रस्थानी आहोत.",
    heroP2: "डॉ. रमाकांत टेकके आणि डॉ. विशाखा टेकके यांच्या मार्गदर्शनाखाली आमचे रुग्णालय अत्याधुनिक वैद्यकीय तंत्रज्ञानाची आणि आपुलकीच्या रुग्णसेवेची सांगड घालते.",
    meetDoctors: "आमच्या डॉक्टरांना भेटा",
    guidingPrinciples: "आमची मार्गदर्शक तत्त्वे",
    missionVisionTitle: "ध्येय आणि दृष्टीकोन",
    missionVisionSub: "स्पष्ट दृष्टी, नैतिक उपचार पद्धती आणि अत्याधुनिक नेत्रसेवेने समाजाचे जीवन उजळवणे.",
    missionTitle: "आमचे ध्येय (Mission)",
    ourPurpose: "आमचा उद्देश",
    missionText: "श्री टेकके आय क्लिनिक, सांगली येथे आमचे ध्येय सर्व वयोगटातील रुग्णांसाठी सर्वसमावेशक, प्रगत आणि परवडणारी नेत्रसेवा प्रदान करणे हे आहे. अचूक निदान, नैतिक वैद्यकीय आचरण आणि आपुलकीने काळजी घेऊन रुग्णांचे दृष्टीदोष दूर करणे आणि त्यांचे जीवनमान उंचावणे हे आमचे कर्तव्य आहे.",
    visionTitle: "आमचा दृष्टिकोन (Vision)",
    ourAspiration: "आमची आकांक्षा",
    visionText: "नेत्ररोग क्षेत्रात उच्च दर्जाच्या वैद्यकीय आणि शस्त्रक्रिया सेवांसाठी एक विश्वासार्ह उत्कृष्ट केंद्र म्हणून नावारूपास येणे. आधुनिक तंत्रज्ञान आणि आरोग्य शिबिरांच्या माध्यमातून टाळता येणारे अंधत्व समूळ नष्ट करणे हे आमचे स्वप्न आहे.",
    tagAccurate: "अचूक निदान",
    tagEthical: "नैतिक उपचार",
    tagAffordable: "परवडणारे दर",
    tagAdvanced: "अद्ययावत तंत्रज्ञान",
    tagExcellence: "वैद्यकीय उत्कृष्टता",
    tagCommunity: "सामाजिक उपक्रम"
  },
  footer: {
    brandDesc: "स्पष्ट दृष्टी. उत्तम काळजी. टाकेविरहित मोतीबिंदू शस्त्रक्रिया, लेझर दृष्टी सुधारणा आणि ६ शाखांमधून सर्वसमावेशक नेत्रसेवेसाठी समर्पित.",
    nabhCare: "NABH मानकानुसार सेवा",
    modernCenters: "६ सुसज्ज केंद्रे",
    connectWithUs: "आमच्याशी जोडून राहा",
    quickLinks: "महत्त्वाचे दुवे",
    ourBranches: "आमच्या शाखा",
    popularServices: "प्रमुख उपचार",
    needHelp: "तात्काळ मदत हवी आहे का?",
    callEmergency: "आपत्कालीन हेल्पलाइन",
    whatsappConsult: "व्हॉट्सॲप सल्लामसलत",
    dailyOpd: "दैनिक ओपीडी वेळ",
    dailyOpdHours: "सोम - शनि: सकाळी ९:०० ते रात्री ८:००",
    allRightsReserved: "सर्व हक्क राखीव.",
    privacyPolicy: "गोपनीयता धोरण",
    termsOfService: "सेवा अटी",
    chooseLanguage: "भाषा"
  },
  servicesList: {
    "lasik-laser": {
      name: "लॅसिक लेझर दृष्टी सुधारणा (Lasik)",
      category: "रिफ्रॅक्टिव्ह शस्त्रक्रिया",
      description: "चष्मा कायमचा घालवण्यासाठी आणि चष्म्याशिवाय स्वच्छ, स्पष्ट दृष्टी मिळवण्यासाठी प्रगत ब्लेड-फ्री लेझर उपचार."
    },
    "multifocal-lens": {
      name: "मल्टीफोकल लेन्स प्रत्यारोपण",
      category: "लेन्स प्रत्यारोपण",
      description: "वाचनाचा चष्मा न वापरता जवळचे, मध्यम आणि दूरचे स्पष्ट दिसण्यासाठी प्रीमियम इंट्राओक्युलर लेन्स (IOL) प्रत्यारोपण."
    },
    "phaco-surgery": {
      name: "फेकोइमल्सिफिकेशन शस्त्रक्रिया (Phaco)",
      category: "मोतीबिंदू उपचार",
      description: "अतिसूक्ष्म छिद्राद्वारे अल्ट्रासाऊंड तंत्रज्ञानाने केलेली सुरक्षित, अचूक आणि जलद दृष्टी देणारी आधुनिक मोतीबिंदू शस्त्रक्रिया."
    },
    "stitchless-cataract-surgery": {
      name: "टाकेविरहित मोतीबिंदू शस्त्रक्रिया (MICS)",
      category: "मोतीबिंदू उपचार",
      description: "कोणतेही इंजेक्शन किंवा टाके न घालता, फोल्डेबल लेन्स बसवून केली जाणारी वेदनारहित आणि त्याच दिवशी घरी जाता येणारी शस्त्रक्रिया."
    },
    "glaucoma-treatment": {
      name: "काचबिंदू उपचार आणि शस्त्रक्रिया",
      category: "काचबिंदू (Glaucoma)",
      description: "डोळ्यांतील वाढलेल्या दाबाचे वेळेवर निदान, व्हिज्युअल फील्ड चाचणी, औषधोपचार आणि प्रगत काचबिंदू शस्त्रक्रिया."
    },
    "squint-treatment": {
      name: "तिरळेपणा शस्त्रक्रिया आणि सुधारणा",
      category: "बालरोग व स्ट्रॅबिस्मस",
      description: "लहान मुले आणि प्रौढांमधील तिरळेपणाचे संपूर्ण निदान, ऑर्थोप्टिक व्यायाम आणि अचूक स्नायू शस्त्रक्रिया."
    },
    "oct-retina-screening": {
      name: "ओसीटी ३डी रेटिना स्कॅनिंग व निदान",
      category: "तपासणी व इमेजिंग",
      description: "ऑप्टिकल कोहिरन्स टोमोग्राफी (OCT) द्वारे रेटिना आणि डोळ्यांच्या नसांचे त्रिमितीय (3D) सूक्ष्म स्कॅनिंग."
    },
    "retina-disorders-surgery": {
      name: "रेटिना विकार निदान व शस्त्रक्रिया",
      category: "व्हिट्रिओरेटिनल केअर",
      description: "रेटिना सरकणे, पडद्याला छिद्र पडणे यावर तज्ज्ञ डॉक्टरांकडून मायक्रोसर्जरी आणि लेझर फोटोकोआग्युलेशन उपचार."
    },
    "oculoplastic-surgery": {
      name: "ऑक्युलोप्लास्टिक व पापणी शस्त्रक्रिया",
      category: "पुनर्रचना शस्त्रक्रिया",
      description: "पापण्यांची दुरुस्ती (Ptosis), अश्रू नलिकांची समस्या आणि डोळ्यांच्या बाहेरील भागाची प्लास्टिक व कॉस्मेटिक शस्त्रक्रिया."
    },
    "pediatric-eye-surgery": {
      name: "बालरोग नेत्र तपासणी व शस्त्रक्रिया",
      category: "बालरोग नेत्रसेवा",
      description: "लहान मुलांमधील जन्मतः मोतीबिंदू, आळशी डोळा (Amblyopia) आणि दृष्टीदोषांवर प्रेमळ व विशेष काळजीपूर्वक उपचार."
    },
    "contact-lens-facility": {
      name: "स्पेशालिटी कॉन्टॅक्ट लेन्स क्लिनिक",
      category: "ऑप्टिकल सेवा",
      description: "सॉफ्ट, टोरिक, मल्टीफोकल आणि आरजीपी कॉन्टॅक्ट लेन्ससाठी अचूक तपासणी आणि योग्य लेन्स देण्याची सुविधा."
    },
    "lasru-dcr-surgery": {
      name: "अश्रू नलिका (DCR / Lasru) शस्त्रक्रिया",
      category: "अश्रू नलिका शस्त्रक्रिया",
      description: "डोळ्यांतून सतत पाणी येणे आणि अश्रू नलिका बंद होण्यावर प्रगत वैद्यकीय उपचार आणि कमीत कमी चीरा असलेली डीसीआर शस्त्रक्रिया."
    },
    "computerized-vision-testing": {
      name: "संगणकीकृत दृष्टी व नंबर तपासणी",
      category: "तपासणी चाचण्या",
      description: "अत्याधुनिक कॉम्प्युटराइज्ड ऑटो-रिफ्रॅक्टोमीटर द्वारे चष्म्याच्या अचूक नंबरची जलद व बिनचूक तपासणी."
    },
    "diabetic-retinopathy": {
      name: "डायबेटिक रेटिनोपॅथी तपासणी व उपचार",
      category: "व्हिट्रिओरेटिनल केअर",
      description: "मधुमेहामुळे डोळ्यांच्या पडद्यावर होणाऱ्या दुष्परिणामांचे वेळेवर निदान, ग्रीन लेझर थेरपी आणि आधुनिक अँटी-VEGF इंजेक्शन्स."
    },
    "general-eye-care": {
      name: "सर्वसमावेशक सामान्य नेत्रोपचार",
      category: "सामान्य नेत्ररोग",
      description: "डोळ्यांचे इन्फेक्शन, ॲलर्जी, ड्राय आय (डोळे कोरडे पडणे), डोळ्यात कचरा जाणे आणि आणीबाणीच्या इजांवर तातडीने उपचार."
    },
    "cornea-disorders-surgery": {
      name: "कॉर्निया विकार व प्रत्यारोपण",
      category: "कॉर्निया उपचार",
      description: "कॉर्नियाचे अल्सर, केराटोकोनस (C3R उपचार), डोळ्यातील मांस वाढणे (टेरिजियम) आणि कॉर्निया प्रत्यारोपण शस्त्रक्रिया."
    }
  },
  branchList: {
    astha: {
      name: "श्री टेकके नेत्र रुग्णालय, आष्टा",
      city: "आष्टा",
      area: "आष्टा",
      address: "रुकडे पेट्रोल पंपाजवळ, स्वागत हॉटेल, पहिला मजला, मेन रोड, आष्टा",
      facilities: ["प्रगत आय ओपीडी", "ऑप्टिकल स्टोअर", "मोतीबिंदू तपासणी", "कॉम्प्युटराइज्ड व्हिजन चेक"]
    },
    jath: {
      name: "श्री टेकके नेत्र रुग्णालय, जत",
      city: "जत",
      area: "जत",
      address: "रुकडे पेट्रोल जल वाडी कॉम्प्लेक्सजवळ, जत",
      facilities: ["सल्लामसलत कक्ष", "ऑप्टिकल केंद्र", "नंबर तपासणी", "फार्मसी"]
    },
    atpadi: {
      name: "श्री टेकके नेत्र रुग्णालय, आटपाडी",
      city: "आटपाडी",
      area: "आटपाडी",
      address: "एस.टी. स्टँडजवळ, रोवत हॉस्पिटलच्या वर, आटपाडी",
      facilities: ["सर्वसमावेशक नेत्रसेवा", "ऑप्टिकल स्टोअर", "निदान तपासणी सुविधा"]
    },
    solapur: {
      name: "राघवेंद्र श्री टेकके नेत्र रुग्णालय, सोलापूर",
      city: "सोलापूर",
      area: "सोलापूर",
      address: "माजी सैनिक नगर, विजापूर रोड, सोलापूर",
      facilities: ["प्रगत शस्त्रक्रिया विभाग", "लेझर उपचार", "ऑप्टिकल स्टोअर", "डायग्नोस्टिक सेंटर"]
    },
    athani: {
      name: "श्री टेकके नेत्र रुग्णालय, अथणी",
      city: "अथणी",
      area: "अथणी",
      address: "शांतीनगर हल्याल क्रुशियल रोड, अथणी",
      facilities: ["सल्लामसलत कक्ष", "ऑप्टिकल स्टोअर", "लहान मुलांची दृष्टी तपासणी"]
    },
    sangola: {
      name: "श्री टेकके नेत्र रुग्णालय, सांगोला",
      city: "सांगोला",
      area: "सांगोला",
      address: "माउली हाइट्स, मिरज रोड, गौरी पेट्रोल पंपाजवळ, सांगोला",
      facilities: ["संपूर्ण नेत्र तपासणी", "चष्मे व लेन्स", "फार्मसी", "मायनर ओटी"]
    }
  },
  doctorsList: {
    "dr-ramakant-tekke": {
      name: "डॉ. रमाकांत टेकके",
      qualification: "नेत्रशल्यविशारद (Ophthalmology)",
      specialization: "नेत्ररोग तज्ज्ञ व सर्जन",
      profile: "डोळ्यांची सर्वसमावेशक काळजी आणि अत्याधुनिक सूक्ष्म शस्त्रक्रियेमध्ये प्रदीर्घ अनुभव असलेले निष्णात नेत्रशल्यचिकित्सक."
    },
    "dr-vishakha-tekke": {
      name: "डॉ. विशाखा टेकके",
      qualification: "M.S. (Opth) & M.B.B.S., D.O.M.S.",
      specialization: "नेत्ररोग तज्ज्ञ व नेत्रशल्यविशारद",
      profile: "आधुनिक दृष्टी सुधारणा प्रक्रिया, मोतीबिंदू शस्त्रक्रिया आणि रुग्णांच्या काळजीपूर्वक उपचारांमध्ये विशेष प्राविण्य."
    }
  }
};
